/**
 * Constantes para el módulo de movimientos bancarios
 */

// Estados de conciliación
export const RECONCILIATION_STATUS = {
  PENDING: false,
  RECONCILED: true,
};

// Categorías de movimientos
export const MOVEMENT_CATEGORIES = {
  INGRESO: 'INGRESO',
  EGRESO: 'EGRESO',
  TRANSFERENCIA: 'TRANSFERENCIA',
  GASTO_BANCARIO: 'GASTO_BANCARIO',
  CHEQUE_EMITIDO: 'CHEQUE_EMITIDO',
  CHEQUE_RECIBIDO: 'CHEQUE_RECIBIDO',
};

// Labels para categorías de movimientos
export const MOVEMENT_CATEGORY_LABELS = {
  [MOVEMENT_CATEGORIES.INGRESO]: 'Ingreso',
  [MOVEMENT_CATEGORIES.EGRESO]: 'Egreso',
  [MOVEMENT_CATEGORIES.TRANSFERENCIA]: 'Transferencia',
  [MOVEMENT_CATEGORIES.GASTO_BANCARIO]: 'Gasto Bancario',
  [MOVEMENT_CATEGORIES.CHEQUE_EMITIDO]: 'Cheque Emitido',
  [MOVEMENT_CATEGORIES.CHEQUE_RECIBIDO]: 'Cheque Recibido',
};

// Tipos de cuenta bancaria
export const ACCOUNT_TYPES = {
  CHECKING_ACCOUNT: 'CHECKING_ACCOUNT',
  SAVINGS_ACCOUNT: 'SAVINGS_ACCOUNT',
};

// Labels para tipos de cuenta
export const ACCOUNT_TYPE_LABELS = {
  [ACCOUNT_TYPES.CHECKING_ACCOUNT]: 'Cuenta Corriente',
  [ACCOUNT_TYPES.SAVINGS_ACCOUNT]: 'Caja de Ahorro',
};

// Colores para estados de conciliación
export const RECONCILIATION_COLORS = {
  PENDING: 'warning',
  RECONCILED: 'success',
};

// Configuración de paginación por defecto
export const DEFAULT_PAGINATION = {
  page: 0,
  rowsPerPage: 100,
};

// Opciones de filas por página
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

// Configuración de fechas por defecto
export const DEFAULT_DATE_RANGE = {
  from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  to: new Date(),
};

// Formato de fecha para inputs
export const DATE_FORMAT = 'yyyy-MM-dd';

// Formato de fecha para visualización
export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';

// Estados iniciales para formularios
export const INITIAL_MOVEMENT_FORM_STATE = {
  uuid_movement_type: '',
  emission_date: new Date(),
  due_date: null,
  amount: '',
  concept: '',
  voucher_number: '',
  uuid_legal_entity: '',
  is_reconciled: false,
  observations: '',
};

export const INITIAL_MOVEMENT_TYPE_FORM_STATE = {
  name: '',
  description: '',
  movement_category: '',
  is_active: true,
};

// Configuración de validación
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: {
    MOVEMENT: ['uuid_movement_type', 'emission_date', 'amount'],
    MOVEMENT_TYPE: ['name', 'movement_category'],
  },
  MIN_AMOUNT: 0.01,
  MAX_AMOUNT: 999999999.99,
  MAX_CONCEPT_LENGTH: 150,
  MAX_VOUCHER_LENGTH: 50,
  MAX_OBSERVATIONS_LENGTH: 500,
};

// Mensajes de error
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Este campo es obligatorio',
  INVALID_AMOUNT: 'El monto debe ser mayor a 0',
  INVALID_DATE: 'Fecha inválida',
  DUE_DATE_BEFORE_EMISSION: 'La fecha de vencimiento no puede ser anterior a la fecha de emisión',
  MAX_LENGTH_EXCEEDED: 'Se ha excedido la longitud máxima permitida',
  NETWORK_ERROR: 'Error de conexión. Verifique su conexión a internet',
  GENERIC_ERROR: 'Ha ocurrido un error inesperado',
};

// Mensajes de éxito
export const SUCCESS_MESSAGES = {
  MOVEMENT_CREATED: 'Movimiento creado exitosamente',
  MOVEMENT_UPDATED: 'Movimiento actualizado exitosamente',
  MOVEMENT_DELETED: 'Movimiento eliminado exitosamente',
  RECONCILIATION_TOGGLED: 'Estado de conciliación actualizado',
  MOVEMENT_TYPE_CREATED: 'Tipo de movimiento creado exitosamente',
  MOVEMENT_TYPE_UPDATED: 'Tipo de movimiento actualizado exitosamente',
  MOVEMENT_TYPE_DELETED: 'Tipo de movimiento eliminado exitosamente',
};

// Configuración de tablas
export const TABLE_CONFIG = {
  STICKY_HEADER: true,
  SIZE: 'small',
  HOVER: true,
  MAX_HEIGHT: 600,
};

// Configuración de diálogos
export const DIALOG_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  FULL_WIDTH: 'fullWidth',
  FULL_SCREEN: 'fullScreen',
};

// Configuración de skeleton loader
export const SKELETON_CONFIG = {
  ROWS: 10,
  ANIMATION: 'wave',
  VARIANT: 'rectangular',
};

// Queries keys para cache
export const CACHE_KEYS = {
  BANK_MOVEMENTS: 'bankMovements',
  BANK_ACCOUNTS: 'bankAccounts',
  MOVEMENT_TYPES: 'movementTypes',
  LEGAL_ENTITIES: 'legalEntities',
};

// Tiempo de cache en milisegundos
export const CACHE_TIME = {
  STALE_TIME: 5 * 60 * 1000, // 5 minutos
  GC_TIME: 15 * 60 * 1000, // 15 minutos
};

// Configuración de exportación
export const EXPORT_CONFIG = {
  FILENAME_PREFIX: 'movimientos_bancarios',
  DATE_FORMAT: 'yyyy-MM-dd',
  EXCEL_EXTENSION: '.xlsx',
  CSV_EXTENSION: '.csv',
};
